import { Interpolation } from 'styled-components';

/** Takes a prop name and two variants.
 * Returns a function which plucks that prop from a props object, and picks the first variant if it's true,
 * or the second variant otherwise
 *
 * Useful inside a styled-components declaration, to replace a messy ternary.
 */
export const propSwitch = <T, Key extends keyof T>(
  key: Key,
  truthyVariant: Interpolation<unknown> | ((props: T) => Interpolation<unknown>),
  falsyVariant: Interpolation<unknown> | ((props: T) => Interpolation<unknown>),
) => (props: T) => (props[key] ? truthyVariant : falsyVariant);
